import { INACTIVE_FILL_OPACITY_LINE_CHART } from '../../../../core/constants.js';
import { ShapeColor } from '../../../../core/types/color-palette.js';
import { SeriesMetadata } from '../../../types/timeseries.js';

const getOpacity = (isCurrentHighlighted: boolean) => {
  return isCurrentHighlighted ? 1 : INACTIVE_FILL_OPACITY_LINE_CHART;
};

export const getLineStyle = (
  series: SeriesMetadata,
  highlightedSeriesId?: string[],
): ShapeColor => {
  if (!highlightedSeriesId) {
    return { color: series.color.Default, opacity: 1 };
  }
  const isCurrentHighlighted = highlightedSeriesId?.includes(series.id);

  return {
    color: series.color.Default,
    opacity: getOpacity(isCurrentHighlighted),
  };
};
